// extracted by mini-css-extract-plugin
module.exports = {"order-details-content":"orderDetailsContent_order-details-content__kmCD2"};